import { ConfigurationWrapper } from "./../digitalfriend/ConfigurationWrapper";
export const applyConfiguration = (
	primaryColor: string,
	secondaryColor: string,
	title: string,
	bgColor: string | null = null,
) => {
	const styleElem = document.getElementById("style_per_org");
	const titleElem = document.querySelector("title");

	if (!styleElem) {
		throw new Error("Style per org element not found!");
	}

	if (styleElem && primaryColor && secondaryColor) {
		styleElem.innerHTML = `
			.bg-primary {
				--tw-bg-opacity: 1;
				background-color: ${primaryColor};
			}

			.bg-secondary {
				--tw-bg-opacity: 1;
				background-color: ${secondaryColor};
			}

			#primary_button {
				border: 1px solid ${primaryColor} !important;
				color: ${primaryColor} !important;
			}
			
			#primary_button:hover {
				background-color: ${primaryColor} !important;
				color: white !important;
				transition: .2s ease-in;
			}
		`;
	}

	if (titleElem) {
		titleElem.innerText = title;
	}

	if (bgColor) {
		document
			.querySelector("body")
			?.style.setProperty("background", `${bgColor}`);
	}
};
